export default __webpack_public_path__ + "assets/whitelabels/smartraha/favicon.ico";